import { render, staticRenderFns } from "./PlanList.vue?vue&type=template&id=01c2d860&scoped=true"
import script from "./PlanList.vue?vue&type=script&lang=js"
export * from "./PlanList.vue?vue&type=script&lang=js"
import style0 from "./PlanList.vue?vue&type=style&index=0&id=01c2d860&prod&scoped=true&lang=css"
import style1 from "./PlanList.vue?vue&type=style&index=1&id=01c2d860&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2d860",
  null
  
)

export default component.exports